module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "hook"
    }
  }, [_c('h1', [_vm._v("Hook")]), _vm._v(" "), _c('p', [_vm._v("Amidst a raging supercell, a sub-surface mining skiff or Skimmer becomes the target of a rogue group intent on securing the technology. Meanwhile, the youthful crew onboard becomes aware of the broader plan for the Skimmers and must find a way to evade capture. Isolated and with help too far away to reach them in time, the crew must act to save themselves, their Skimmer, and the technology.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0